// extracted by mini-css-extract-plugin
module.exports = {"email-screen":"EmailScreen_email-screen__ZXhot","emailScreen":"EmailScreen_email-screen__ZXhot","input":"EmailScreen_input__keuc3"};